import React, { useState, useEffect } from 'react'
import './style.css'

function MarqueeText({ children }) {
  const [position, setPosition] = useState(0)

  useEffect(() => {
    const marqueeElement = document.querySelector('.marquee')

    const resetPosition = () => {
      setPosition(0)
      marqueeElement.style.transform = 'translateX(0)'
    }

    const handleAnimationEnd = () => {
      resetPosition()
    }

    marqueeElement.addEventListener('animationend', handleAnimationEnd)

    return () => {
      marqueeElement.removeEventListener('animationend', handleAnimationEnd)
    }
  }, [])

  return (
    <div className="marquee-container">
      <div
        className="marquee"
        style={{ transform: `translateX(-${position}px)` }}
      >
        {children}
      </div>
    </div>
  )
}

export default MarqueeText
